import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import queryString from 'query-string'
import Survey from '@components/Survey'
import Loader from '@ui/Loader'
import { callFingerPrinting } from './utils'

@withRouter
@inject('surveyState', 'user', 'authentication')
@observer
class Surveys extends Component {
  state = {
    loading: true
  }

  async componentDidMount() {
    const { surveyState, match, location, history, user, authentication } =
      this.props
    const { id } = match.params || {}
    const params = queryString.parse(location.search) || {}

    window.onbeforeunload = this.onUnload
    authentication.cleanStorage()
    surveyState.setParams(id, params)
    user.setSignature(params.signature)
    await Promise.all([surveyState.getSurvey(), surveyState.getLanguages()])
    callFingerPrinting({
      isSelfAssessment: surveyState.isSelfAssessment,
      signature: params.signature
    })
    if (surveyState.error) {
      if (!surveyState.isRedirecting) history.push('/error')
    } else {
      surveyState.startSurvey()
      this.setState({ loading: false })
    }
  }

  componentWillUnmount() {
    window.onbeforeunload = null
  }

  onUnload = () => alert('Reload site', 'Changes you made may not be saved.')

  nextQuestion = async questionId => {
    const { surveyState } = this.props
    window.scroll({ top: 0, left: 0 })
    clearTimeout(this.timeout)

    if (surveyState.isCompleted) {
      await this.storePartials(questionId)
    } else {
      this.timeout = setTimeout(() => this.storePartials(questionId), 1000)
    }
  }

  handleFinish = () => this.props.surveyState.submitSurvey()

  async storePartials(questionId) {
    const { surveyState } = this.props

    if (questionId) {
      await surveyState.saveAnswers(questionId)
    }
  }

  render() {
    return this.state.loading ? (
      <Loader />
    ) : (
      <Survey
        onNext={this.nextQuestion}
        onFinish={this.handleFinish}
        updating={this.props.surveyState.changingLanguage}
      />
    )
  }
}

export default Surveys
